import DexLeftComponent from '@/components/DexLeftComponent';
import usePage from '@/hooks/use-page';
import { useNavigate } from '@/lib/router-dom';

const Page = () => {

	const { goTo } =  useNavigate()

	usePage({ title: 'Reset Password' })

	const resetPasswordStyles = {
		backgroundImage: `url("/sgtradex-cover-login.png")`
	}

	/*=================================================
		MultiDex
	/================================================*/

	return (
		<div className='layout-login'>
			<DexLeftComponent />
			<div className="layout-login__right">
				<div className="login-box">
					<div className="resetPassword-box__title">Reset Password</div>
                    <div className="resetPassword-box__desc">New password successfully set</div>
					<div className="resetPassword-box__form">
						<form data-testid="form" onSubmit={()=>(goTo('/login'))}>
                            <div className="resetPassword-box__form__action">
                                <div>
                                    <button type="submit" className="button--rounded resetPassword-box__button" value="Submit">Go to Log In</button>
                                </div>
                            </div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}
export default Page
